import { Component, inject, OnInit } from '@angular/core';
import { CustomUserDropdownItem } from '@galaxy/atlas';
import { AuthService } from './core/auth/auth.service';
import { GalaxyAiIconService } from '@vendasta/galaxy/ai-icon';
import { EnvironmentService } from '@galaxy/core';
import { MatIconRegistry } from '@angular/material/icon';

@Component({
  selector: 'app-authed-app',
  templateUrl: './authed-app.component.html',
  styleUrls: ['./authed-app.component.scss'],
  standalone: false,
})
export class AuthedAppComponent implements OnInit {
  private authService = inject(AuthService);
  private aiIconService = inject(GalaxyAiIconService);
  private envService = inject(EnvironmentService);

  constructor(private matIconReg: MatIconRegistry) {}

  ngOnInit(): void {
    this.matIconReg.setDefaultFontSetClass('material-symbols-outlined');
  }

  dropdownItems: CustomUserDropdownItem[] = [
    {
      label: 'Logout',
      callback: () => this.logout(),
    },
  ];

  logout(): void {
    this.authService.logout({ namespace: 'VA' });
  }
  getEnv(): string {
    return this.envService.getEnvironmentString();
  }
}
